import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as CheckIcon } from '../../../../../assets/icons/check_purple_icon.svg';
import { getActions, navigateToView } from "store/appTrack/actions";
import { useNavigate } from "react-router-dom";
import { claimActive, updateFormField } from "store/forms/actions";
import { isAuditor, isBeneficiary, isForeign, isObjectionCommittee }  from 'utils';
import { Spin } from "antd";

const ActionList = (props) =>{
    //const view = useSelector(state => state.appTrack.permissions.view)
    const [isReady, setIsReady] = useState(false);
    const [error, setError] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const view = useSelector(state => state.appTrack.permissions.view);
    const edit = useSelector(state => state.appTrack.permissions.edit);
    const cancel = useSelector(state => state.appTrack.permissions.cancel);
    const groups = useSelector(state => state.user.groups);
    const variables = useSelector(state => state.appTrack.variables);
    const unassign = useSelector(state => state.appTrack.permissions.unassign);
    const submitObjection = useSelector(state => state.appTrack.permissions.submitObjection);
    const [isForeignSupplier, setIsForeignSupplier] = useState(false);

    const appTrackVariables = useSelector(state => state.appTrack.variables);

    function getIsForeignSupplier(variables, id) {
      const found = variables.find(item => item.id === id);
      return found?.isForeignSupplier ?? false;
    }

    useEffect(()=> {
      const isForeignSupplier = getIsForeignSupplier(appTrackVariables, props.id)
      setIsForeignSupplier(isForeignSupplier)
    },[props.id])

    const onUnassignService = () => {
      props.open(false)
      props.setUnassignModalService(true)
    }

    console.log('isForeignSupplier: ', isForeignSupplier)

    useEffect(() => {
      let mounted = true;

      const initializeActions = () => {
          dispatch(getActions(props.id))
              .then(() => {
                  if (!mounted) return;
                  
                  if (typeof view !== 'undefined' && 
                      typeof edit !== 'undefined' && 
                      typeof cancel !== 'undefined') {
                      setIsReady(true);
                  }
              })
              .catch((error) => {
                  if (!mounted) return;
                  console.error('Failed to initialize actions:', error);
                  setError(error);
              });
      };
      
      initializeActions();

      // cleanup to prevent mem leaks
      return () => {
          mounted = false;
      };
  }, [dispatch, props.id, view, edit, cancel]);


    // Error state
    if (error) {
      return (
          <div className="popover-container">
              <div className="popover-item" style={{ color: 'red', padding: '12px' }}>
                  Failed to load actions
              </div>
          </div>
      );
  }

  // loading state ...
  if (!isReady) {
      return (
          <div id={`action-list-for-${props.id}`} className="popover-container">
              <div className="popover-item" style={{ textAlign: 'center', padding: '12px' }}>
                  <Spin size="small" />
              </div>
          </div>
      );
  }

    // useEffect(() => {
    //   dispatch(getActions(props.id));
    //   console.log("editENTERED:",edit);
    // }, [])

    const onView = (value) => {
      props.open(false);
      navigateToView(navigate, props.id);
    }

    const onEdit = (value) => {
      dispatch(
        updateFormField({
          group: 'task',
          key: 'processInstanceId',
          value: props.id
            
        })
      ); 
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'viewMode',
          value: false
           
        })
      );
      isBeneficiary(groups)
        ? isForeign(groups) 
          ? dispatch(claimActive(navigate, props.id, null, "foreign", isForeignSupplier)) 
            : dispatch(claimActive(navigate, props.id, null, "beneficiary", isForeignSupplier))
        : isAuditor(groups)
          ? dispatch(claimActive(navigate, props.id, null, "auditor", isForeignSupplier))
          : dispatch(claimActive(navigate, props.id, null, "installer", isForeignSupplier));    }

    // const onCancel = (value) => {
    //   props.open(false);
    //   console.log("bike sto cancel",props.id);
    //   dispatch(cancelProcessInstance(props.id));
    // }

  const onCancel = () => {
      props.open(false)
      props.setCancelModal(true)
  }

  const onCancelEquipment = () => {
    props.open(false)
    props.setCancelModalEquipment(true)
}

  const onCancelService = () => {
    props.open(false)
    props.setCancelModalService(true)
  }

  const renderEditLabel = (groups) => {
    if (isAuditor(groups)) {
      return <span>Αξιολόγηση <CheckIcon className="check" /></span>;
    }else if(isObjectionCommittee(groups)){
      return <span>Αξιολόγηση Ένστασης <CheckIcon className="check" /></span>;
    }else {
      return <span>Επεξεργασία <CheckIcon className="check" /></span>;
    }
  };

    return(
        <div id={`action-list-for-${props.id}`} className="popover-container">
            { view ? <div id="action-button-view" className="popover-item" onClick={()=>onView(props.id)}>Προβολή <CheckIcon className="check"/></div>: null }
            { edit ? <div id="action-button-edit" className="popover-item" onClick={()=>onEdit(props.id)}>{renderEditLabel(groups)}</div> : null }
            { submitObjection ? <div id="action-button-submitObjection" className="popover-item" onClick={()=>onEdit(props.id)}><span>Ένσταση <CheckIcon className="check"/></span></div> : null }
            { cancel ? <div id="action-button-cancel" className="popover-item" onClick={()=>onCancel(props.id)}><span>Ακύρωση Αίτησης <CheckIcon className="check"/></span></div> : null }
            { unassign ? <div id="action-button-unassign" className="popover-item" onClick={()=>onUnassignService(props.id)}><span>Ανάθεση σε άλλον αξιολογητή<CheckIcon className="check"/></span></div> : null }
            
        </div>
    )
}

export default ActionList;